// PRD 11 §2.2 #8 — single Grade badge per row/preview.
//   G1 (단계 1, 예방적 관리)   → 초록 --grade-g1
//   G2 (단계 2, 자가처치)      → 노랑 --grade-g2
//   G3 (단계 3, 의료진 상담)   → 주황 --grade-g3
//
// SHCT-841 — this used to hard-code a pale bg / colored text pair taken from an older
// prototype gradeBadge(). The confirmed badge is the shared `.grade grade-gN` token: a solid
// token background with white text, identical to PRO 항목설계's Grade cutoff badges.
// PRD 11 §1 defers to PRD 07's Grade system, and PRD 07 §4 defines that shared token
// (v1.7 2026.06.11 "Grade 뱃지 색상 정정(초록/노랑/주황·PRO항목설계와 동일)"). PRD 07 §2.2 /
// PRD 11 §2.2 still print the pre-v1.7 "파랑/빨강" wording — doc drift, reported on the ticket.

import { useTranslation } from 'react-i18next';

import type { ManualGrade } from '../types/counseling-manual.types';

// Neutral badge for a DRAFT saved without a grade (grade === null). No `.grade` token covers
// "no grade", so this one stays a plain muted badge.
const NONE_STYLE = { background: 'var(--muted)', color: 'var(--muted-foreground)' };

interface GradeBadgeProps {
  grade: ManualGrade | null;
}

export function GradeBadge({ grade }: GradeBadgeProps) {
  const { t } = useTranslation('counseling-manual');
  if (!grade) {
    return (
      <span className="badge" style={NONE_STYLE}>
        {t('gradeLabels.none')}
      </span>
    );
  }
  return (
    <span className={`grade grade-${grade.toLowerCase()}`}>{t(`gradeLabels.${grade}`)}</span>
  );
}
